<template>
  <keep-alive>
    <div v-if="!hasPermissions" class="d-flex flex-column align-items-center mx-auto" style="max-width: 600px; margin-top: 150px;">
      <h2 style="color: red;">
        Forbidden!
      </h2>
      <h3>
      Inspector Routing is only available to users in "Inspection Routers" group!
      </h3>
    </div>
    <div v-else>
      <h3 v-if="isSimulation">Inspector Routing Simulation</h3>
      <h3 v-else>Inspection Routing Solver</h3>
      <div class="row d-flex w-100 justify-content-between">
        <div class="card col-12 col-lg-4" style="min-width:370px; margin-right:5px;">
          <div class="card-header mx-auto pb-3" style="border-bottom: solid 1px #bbbbbb;">
            <el-switch v-model="isSimulation"
                       active-text="Simulation"
                       inactive-text="Actual Routing"
                       :disabled="controlsDisabled"
                       @change="clearData"
            />
          </div>
          <div class="card-body">
            <div class="w-100 pb-4">
              <label class="w-100">Date to Route</label>
              <el-date-picker :format="constants.DATE.FORMAT.DISPLAY"
                              :value-format="constants.DATE.FORMAT.VALUE"
                              :picker-options="isSimulation ? simPickerOptions : solvePickerOptions"
                              v-model="routingDate"
                              :disabled="controlsDisabled"
                              class="w-100"
              />
            </div>
            <div class="w-100 pb-4">
              <label class="w-100">Department to Route</label>
              <el-select  class="w-100"
                          v-model="department"
                          :disabled="controlsDisabled"
              >
                <el-option v-for="department in filteredDepartmentsForSelect"
                           :label="department.label"
                           :value="department.value"
                           :key="department.value"
                />
              </el-select>
            </div>
            <div class="w-100 pb-4">
              <label class="w-100">Service Areas to Route</label>
              <el-select  class="w-100"
                          multiple
                          v-model="serviceAreas"
                          :disabled="controlsDisabled"
              >
                <el-option v-for="serviceArea in serviceAreasForSelect"
                           :label="serviceArea.label"
                           :value="serviceArea.value"
                           :key="serviceArea.value"
                />
              </el-select>
            </div>
            <div class="d-flex justify-content-around pb-3">
              <el-button style="width:50%;"
                         type="primary"
                         plain
                         @click="openSolverConfig"
                         :disabled="controlsDisabled"
              >
                Solver Config
              </el-button>
              <el-button style="width:50%;"
                         type="primary"
                         @click="runSolver"
                         :disabled="solveDisabled ||controlsDisabled || !routingDate"
              >
                {{runButtonLabel}}
              </el-button>
            </div>
          </div>
        </div>

        <div v-if="isProcessing || resultsReturned" class="col card" style="flex-grow: 1; margin-left:5px;">
          <div v-if="!tablesCached" class="card-body h-100 d-flex flex-column align-items-center rounded-xl" >
            <div class="py-4">
              <img :class="`${solverStatus === constants.INSPECTOR_ROUTING.SOLVER_STATUS.NOT_SOLVING ? 'opacity-0' : ''}`"
                   style="width:300px; border-radius: 15px; box-shadow: #141E30; overflow: hidden;"
                   src="https://s3.amazonaws.com/cdn.ats-ptrac.com/wait-gif/wait-1.gif"
                   alt="Loading..."
              />
            </div>
            <h3>{{ solverStatusMessage }}</h3>
            <el-progress :percentage="solverProgressPercentage"
                         class="w-50"
                         color="#4aa3bb"
                         :stroke-width="12"
                         :show-text="false"
            />
          </div>
          <div v-if="solverFinished">
            <solution-stats v-if="!solverFailed" />
            <div v-else class="card-body h-100 d-flex flex-column align-items-center ">
              <img class="icon py-4"
                   style="width:150px"
                   src="static/img/active-error.png"
                   alt="Error"
              />
              <h3 class="mt-15 text-danger">Solver Failed!</h3>
            </div>
          </div>
        </div>
        <div v-if="resultsReturned && !solverFailed" :class="`${tablesCached ? '' : 'd-none'} w-100`">
          <div class="row" style="height: 650px;">
            <div :class="`card d-flex h-100 w-100 col-12 mb-3 px-0 ${showMap ? 'col-lg-7' : ''}`" style="max-height:650px; transition: all 500ms ease-in-out;">
              <div class="card-header">
                <div class="row d-flex align-items-center justify-content-between">
                  <h5 class="mb-0">Assignments</h5>
                  <div class="col-12 col-sm-8 d-flex align-items-center justify-content-end p-0">
                    <el-radio-group v-model="selectedTableFormatLabel" @change="handleChangeTableFormat">
                      <el-radio-button :label="constants.ROUTING_TABLE_FORMATS.BY_INSPECTOR.label"></el-radio-button>
                      <el-radio-button :label="constants.ROUTING_TABLE_FORMATS.BY_PROJECT.label"></el-radio-button>
                      <el-radio-button :label="constants.ROUTING_TABLE_FORMATS.CUSTOM.label"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <div :class="`card-body d-flex flex-grow-1`">
                <keep-alive>
                  <custom-table v-if="selectedTableFormat === constants.ROUTING_TABLE_FORMATS.CUSTOM.value"
                                :tablesCached="tablesCached"
                  />
                  <routing-table v-else-if="selectedTableFormat === constants.ROUTING_TABLE_FORMATS.BY_INSPECTOR.value
                                          || selectedTableFormat === constants.ROUTING_TABLE_FORMATS.BY_PROJECT.value"
                                 :tableFormat="selectedTableFormat"
                                 :tablesCached = tablesCached
                                 :key="selectedTableFormat"
                  />
                </keep-alive>
              </div>
            </div>
            <Transition>
              <div :class="`${!showMap ? 'd-none' : ''} col-12 col-lg-5 h-100 mb-3 pl-2 pr-0`">
                <div :class="`${mapLoaded ? 'map-visible' : 'map-hidden'}`" style="transition: all 0.5s ease-in-out">
                  <keep-alive>
                    <routing-map />
                  </keep-alive>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </div>
    </div>
  </keep-alive>
</template>

<script>
import Constants from '@/utilities/constants'
import {sync} from 'vuex-pathify'
import {CheckboxGroup, Progress, RadioButton, RadioGroup, Switch} from 'element-ui'
import SolutionStats from './SolutionStats'
import RoutingMap from './RoutingMap.vue'
import {mapGetters} from "vuex";
import CustomTable from './CustomTable'
import RoutingTable from './RoutingTable'
import _ from 'lodash'
import {nextBusinessDay} from '@/utilities/utils'

export default {
  name: 'InspectorRouting',
  components: {
    RoutingTable,
    elCheckboxGroup: CheckboxGroup,
    elProgress: Progress,
    elRadioButton: RadioButton,
    elRadioGroup: RadioGroup,
    elSwitch: Switch,
    SolutionStats,
    CustomTable,
    RoutingMap
  },
  computed: {
    isSimulation: sync('inspectorRouting/solverParams@isSimulation'),
    routingDate: sync('inspectorRouting/solverParams@dateToRouteInspectors'),
    serviceAreas: sync('inspectorRouting/solverParams@serviceAreaIdsToRoute'),
    department: sync('inspectorRouting/solverParams@departmentIdToRoute'),
    selectedInspectionIds: sync('inspectorRouting/selectedInspectionIds'),
    solverFailed: sync('inspectorRouting/solverFailed'),
    ...mapGetters ({
      departmentsForSelect: 'departments/kvpsForSelect',
      serviceAreasForSelect: 'serviceAreas/kvpsForSelect',
      solverStatus: 'inspectorRouting/solverStatus',
      user: 'security/user'
    }),
    hasPermissions() {
      return this.$store.get('security/isInGroup', Constants.GROUPS.SUPER_USERS)
        || this.$store.get('security/isInGroup', Constants.GROUPS.INSPECTION_ROUTERS)
    },
    filteredDepartmentsForSelect() {
      return this.departmentsForSelect.filter(
        department => [Constants.DEPARTMENTS.INSPECTIONS, Constants.DEPARTMENTS.ENERGY].includes(department.label))
    },
    selectedTableFormat() {
      const selectedFormat = Object.values(Constants.ROUTING_TABLE_FORMATS)
        .find(format => format.label === this.selectedTableFormatLabel)

      return selectedFormat.value
    },
    runButtonLabel() {
      if (this.isProcessing) {
        return "Processing . . ."
      }
      if (this.resultsReturned && this.isSimulation) {
        return "Re-run Simulation"
      }
      if (this.resultsReturned) {
        return "Re-run Solver"
      }
      if (this.isSimulation) {
        return "Run Simulation"
      }
      return "Run Solver"
    },
    solverStatusMessage() {
      switch (this.solverStatus) {
        case Constants.INSPECTOR_ROUTING.SOLVER_STATUS.NOT_SOLVING: {
          return "Solver Idle"
        }
        case Constants.INSPECTOR_ROUTING.SOLVER_STATUS.PREPARING: {
          return "Analyzing recent inspections . . ."
        }
        case Constants.INSPECTOR_ROUTING.SOLVER_STATUS.SOLVING: {
          return "Routing Inspectors . . ."
        }
        case Constants.INSPECTOR_ROUTING.SOLVER_STATUS.PROCESSING: {
          return "Processing results . . ."
        }
        case Constants.INSPECTOR_ROUTING.SOLVER_STATUS.LOADING_TABLES: {
          return "Populating tables . . ."
        }
      }
    },
    solverProgressPercentage() {
      switch (this.solverStatus) {
        case Constants.INSPECTOR_ROUTING.SOLVER_STATUS.NOT_SOLVING: {
          return 0
        }
        case Constants.INSPECTOR_ROUTING.SOLVER_STATUS.PREPARING: {
          return 20
        }
        case Constants.INSPECTOR_ROUTING.SOLVER_STATUS.SOLVING: {
          return 40
        }
        case Constants.INSPECTOR_ROUTING.SOLVER_STATUS.PROCESSING: {
          return 75
        }
        case Constants.INSPECTOR_ROUTING.SOLVER_STATUS.LOADING_TABLES: {
          let tableProgress = 0
          for (const table of Object.values(this.tableCached)) {
            if (table) {
              tableProgress += 5
            }
          }
          return 85 + tableProgress
        }
      }
    },
    tablesCached() {
      return this.tableCached[Constants.ROUTING_TABLE_FORMATS.BY_INSPECTOR.label] === true
        && this.tableCached[Constants.ROUTING_TABLE_FORMATS.BY_PROJECT.label] === true
        && this.tableCached[Constants.ROUTING_TABLE_FORMATS.CUSTOM.label] === true;
    },
    controlsDisabled() {
      return this.isProcessing || (this.resultsReturned && !this.tablesCached)
    },
    solveDisabled() {
      return this.serviceAreas.length === 0 || !this.department || !this.routingDate
    },
    solverFinished() {
      return this.resultsReturned && this.tablesCached
    },
    showMap() {
      return this.selectedTableFormat === Constants.ROUTING_TABLE_FORMATS.BY_INSPECTOR.value
        || this.selectedTableFormat === Constants.ROUTING_TABLE_FORMATS.BY_PROJECT.value
    }
  },
  data() {
    return {
      constants: Constants,
      activeNames: [],
      isProcessing: false,
      resultsReturned: false,
      tableCached:   {
        [Constants.ROUTING_TABLE_FORMATS.CUSTOM.label]: false,
        [Constants.ROUTING_TABLE_FORMATS.BY_INSPECTOR.label]: false,
        [Constants.ROUTING_TABLE_FORMATS.BY_PROJECT.label]: false
      },
      mapLoaded: false,
      clusteredMarkersSelected: false,
      selectedTableFormatLabel: null,
      simPickerOptions: {
        disabledDate(date) {
          // For simulation, disable dates past today (need to have actual assignments)
          // and before 04-01-2023 (when there's a few days of full prod data to work with)
          const today = new Date()
          today.setHours(0,0,0,0)
          return date < new Date('2023-04-01') || date > today;
        }
      },
      solvePickerOptions: {
        disabledDate(date) {
          // For actual routing, disable all days in the past
          const today = new Date()
          today.setHours(0,0,0,0)
          return date < today
        }
      },
    }
  },
  methods: {
    openSolverConfig() {
      this.$eventHub.$emit('show-modal-1', "Solver Configuration", null, '600px')
    },
    handleChangeTableFormat() {
      this.$eventHub.$emit('stopBounceOnAll')
    },
    async runSolver() {
      this.clearData()
      this.isProcessing = true
      await this.$store.dispatch('inspectorRouting/solveRouting')
      this.selectAllInspectionsOnLoad()
      this.isProcessing = false
      this.resultsReturned = true

      await this.precacheTables()
    },
    selectAllInspectionsOnLoad() {
      const results = this.$store.get('inspectorRouting/results')
      for (const inspection of results) {
        this.selectedInspectionIds.add(inspection.ptracTaskId)
      }
    },
    async precacheTables() {
      const initialSelectedTableFormatLabel =_.clone(this.selectedTableFormatLabel)
      this.selectedTableFormatLabel = Constants.ROUTING_TABLE_FORMATS.BY_INSPECTOR.label

      setTimeout(()=> {
        this.tableCached[this.selectedTableFormatLabel] = true
        this.selectedTableFormatLabel = Constants.ROUTING_TABLE_FORMATS.BY_PROJECT.label

        setTimeout(() => {
          this.tableCached[this.selectedTableFormatLabel] = true
          this.selectedTableFormatLabel = Constants.ROUTING_TABLE_FORMATS.CUSTOM.label

          setTimeout(() => {
            this.tableCached[this.selectedTableFormatLabel] = true
            this.selectedTableFormatLabel = initialSelectedTableFormatLabel
            this.$store.set('inspectorRouting/solverStatus', Constants.INSPECTOR_ROUTING.SOLVER_STATUS.NOT_SOLVING)
          }, 1000)
        }, 1000)
      }, 1000)
    },
    setAllTableCached(bool) {
      this.tableCached[Constants.ROUTING_TABLE_FORMATS.BY_INSPECTOR.label] = bool
      this.tableCached[Constants.ROUTING_TABLE_FORMATS.BY_PROJECT.label] = bool
      this.tableCached[Constants.ROUTING_TABLE_FORMATS.CUSTOM.label] = bool
    },
    clearData() {
      this.activeNames = []
      this.solverFailed = false
      this.resultsReturned = false
      this.selectedInspectionIds = new Set()
      this.setAllTableCached(false)
      this.mapLoaded=false
      this.$store.set('inspectorRouting/solverStatus', Constants.INSPECTOR_ROUTING.SOLVER_STATUS.NOT_SOLVING)
      this.$store.set('inspectorRouting/query', "")
      this.$store.commit('inspectorRouting/resetResults')
    },
    setDefaultDepartment() {
      const userDefaultDepartment = _.get(this.user, 'preferences.global.defaultDepartment')
      const matchingDepartment = this.filteredDepartmentsForSelect.find(department => department.value === userDefaultDepartment)
      if (userDefaultDepartment && matchingDepartment) {
        this.department = matchingDepartment.value
      } else {
        this.department = this.filteredDepartmentsForSelect.length ? this.filteredDepartmentsForSelect[0].value : undefined
      }
    }
  },
  async beforeMount() {
    if (!this.$sidebar.isMinimized) {
      this.$sidebar.toggleMinimize()
    }
    await this.$store.dispatch('users/fetchAllInspectors')
    await this.$store.dispatch('serviceAreas/fetchAll')

    this.setDefaultDepartment()
    this.serviceAreas = this.serviceAreasForSelect.map(serviceArea => serviceArea.value)
  },
  mounted() {
    this.selectedTableFormatLabel = Constants.ROUTING_TABLE_FORMATS.BY_INSPECTOR.label

    if (this.routingDate === this.$store.get('inspectorRouting/resultsRoutingDate')) {
      this.resultsReturned = true
      this.precacheTables()
    }
    this.$eventHub.$on('mapLoaded', (bool) => this.mapLoaded=bool)
  },
  beforeDestroy() {
    if (this.$sidebar.isMinimized) {
      this.$sidebar.toggleMinimize()
    }
    this.$eventHub.$off('mapLoaded')
  },
  watch: {
    isSimulation: {
      handler: function(isSimulation) {
        if (isSimulation) {
          this.routingDate = new Date(new Date().getTime() - Constants.TIME.ONE_DAY)
        } else {
          this.routingDate = nextBusinessDay()
        }
      }
    }
  }
}
</script>

<style scoped>

  .map-hidden {
    visibility: hidden;
    opacity:0;
    max-height: 0;
  }

  .map-visible {
    display: block;
    visibility: visible;
    opacity:1;
    max-height: 1000px;
  }

  .info-tooltip {
    height:20px;
    width:17px;
    position:absolute;
  }

  .row {
    margin-left: auto;
    margin-right:auto;
  }

  >>>.el-radio-button {
    margin-bottom: 0;
  }

  >>>.el-radio-button__inner {
    padding:12px 12px!important;
  }

  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }


/*  Tables */
  >>> .el-checkbox {
    margin: 0!important;
    padding: 0!important;
  }

  >>>.is-indeterminate .el-checkbox__inner {
    background-color: #9cbecd!important;
    border-color:#4aa3bb!important;
  }

  >>>.indeterminate .el-checkbox__inner {
    background-color: #9cbecd!important;
    border-color:#4aa3bb!important;
  }

  >>>.indeterminate .el-checkbox__inner::before {
    opacity:100!important;
  }

  >>>.custom-checkbox {
    top: 0.5px!important;
  }

  >>>.custom-checkbox .el-checkbox__inner::before {
    content: '_';
    position: absolute;
    left: 1.5px;
    top: -14px;
    font-size: 16px;
    transform: scaleX(0.7) scaleY(1.3);
    color: white;
    z-index: 100;
    pointer-events:none;
    transition:opacity 0.4s ease-in-out;
    opacity:0;
  }

  >>>.custom-checkbox div {
    padding: 5px!important;
  }

  >>>.none-checked .el-checkbox__inner {
    background-color: white!important;
  }

  >>>.assignment-match {
    background-color: #99dd99!important;
  }

  >>>.assignment-non-match {
    background-color: #ffb0c5!important;
  }

  >>>.manually-assigned-inspector {
    background-image:
      radial-gradient(
        circle closest-side,
        white 50%,
        #ffd99b
      )!important;;
    background-color: #ffd99b!important;
  }

  >>>.unavailable-manually-assigned-inspector {
    background-image:
      radial-gradient(
        circle closest-side,
        white 50%,
        #ff6666
      )!important;
    background-color: #ff6666!important;
  }

  >>>.manually-reassigned {
    background-image:
      radial-gradient(
        circle closest-side,
        white 50%,
        #87CB16
      )!important;;
    background-color: #87CB16!important;
  }

  >>>.reinspection {
    background-image:
      radial-gradient(
        circle closest-side,
        white 50%,
        #5cd8ff
      )!important;
    background-color: #5cd8ff!important;
  }

  >>>.tooltip-cell .cell, .header-tooltip .cell {
    display: flex;
    align-items: center;
    width: fit-content;
    padding: 0!important;
    margin:auto;
  }

  >>>.tooltip-cell .cell div{
    display: flex;
    align-items: center;
  }

  >>>.tooltip-cell .cell .el-table__indent {
    display: none!important;
  }

  >>>.tooltip-cell .cell .el-table__placeholder {
    display: none!important;
  }

  >>>.parent-row .cell {
    margin-left:2px!important;
    padding-left:0!important;
  }

</style>
